
const NPSQuestionnaireAlreadySubmitted = ({ loading }) => {
    return (
        <>
            <div className="content-wrapper">
                <div className="middle-content-wrapper">
                    <div className="text-content">
                        <div className="already-submitted">
                            <div className="check">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <div>
                                <p className="text-center already-submitted-text">
                                    The feedback has already been submitted.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NPSQuestionnaireAlreadySubmitted